import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'full_address_localize'

export const dataPointDefinition = {
  retracedId: 'full_address_localize',
  name: 'Full Address (in local language as per business license):',
  description:
    'Only applicable if your facility has an address/also has an address in a language other than English.\r\r\n\r\r\nFacility Address is the address on the business license(s) associated with the facility name. \r\r\n\r\r\nInsert Street, City, State/Province, Zip Code/Postal Code all in one response field. ',
  meta: {},
  fieldTypeId: 'LONG_TEXT',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bi-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 140,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
